import axios from 'axios';
import config from '../config';

const GenderGetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'gender/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                genders: response.data.genders
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

export { GenderGetAll };